<template>
  
  <header class="flex flex-col md:flex-row items-center justify-start bg-[#474747]">
    
    <div class="flex">
      <!-- Imagen alineada a la izquierda -->
      <img class="py-5 max-h-full object-contain" src="@/assets/logo.png" />
    </div>

    <div class="flex flex-col flex-grow ml-4 pb-4 md:pb-0 md:text-xl">
      <!-- Textos alineados a la derecha -->
      <h1 class="text-center md:text-right font-custom-light text-white pr-0 md:pr-10">
        18 y 19 de marzo 2026
      </h1>
      <h1 class="text-center md:text-right font-custom-light text-white pr-0 md:pr-10">
        #21 | Presencial - Hotel Quinto Centenario Córdoba
      </h1>
    </div>

  </header>

</template>



<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'HeaderSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>